import BODLayout from './bodLayout';

const Bodanjani = () => {

    return (
        <BODLayout
            name='Mr. Rajiv Rai'
            about={
                <>
                   Rajiv Rai is a business leader, digital expert and one of the pioneers in the field of financial digitalization in the country. He is an engineer from IIT Madras and an MBA from IIM Ahmedabad with 25 years of experience.<br /><br />
                   
                   In his last job as the Chief Digital Officer for the Edelweiss Group, he helped the group become more retail-oriented and digitally enabled, shrinking time and effort in decisioning and on-boarding customers in businesses like Loans, Investment and Insurance.
                    As the COO and Head - Alternate Channels for Deutsche Consumer Bank, he helped the bank become sustainably profitable through a lean and optimally staffed Operations and Service team supported by digital online processes.
                    While leading the Internet Banking initiatives in Citibank, he ideated various innovations including SMS banking, bill payment & online acquisition of NRI customers, which helped position Citibank as the leader in this rapidly evolving space.
                    Founded an internet services company in the early days of the dotcom era, that developed website and online applications for companies in India and USA including Citibank, Ingersoll Rand and the Eenadu newspaper group.
                </>
            }
            img='/assets/rajiv_rai.jpg'
            designation='Independent Director'
        />
    )
}
export default Bodanjani;